<template>
  <div class="tw-mt-2">
    <div
      v-for="(q, idx) in data.questions"
      :key="idx"
      class="tw-flex tw-justify-between tw-gap-2 tw-py-0.5"
    >
      <WdsText :text="q.text" secondary sm class="tw-flex-1" />
      <WdsText :text="formatAnswer(q.answer) ?? $t('—')" sm :secondary="q.answer === null" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { ComplianceClassificationAnswer } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const ComplianceDataClassificationFragment = graphql(`
  fragment ComplianceDataClassification on ComplianceDataClassification {
    questions {
      text
      helpText
      answer
    }
  }
`)

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataClassificationFragment> }>()
const data = computed(() => useFragment(ComplianceDataClassificationFragment, props.entry))

function formatAnswer(answer: ComplianceClassificationAnswer | null | undefined) {
  if (!answer) return null
  switch (answer) {
    case ComplianceClassificationAnswer.Yes:
      return $t('Yes')
    case ComplianceClassificationAnswer.No:
      return $t('No')
    case ComplianceClassificationAnswer.Unknown:
      return $t('Unknown')
    default:
      return null
  }
}
</script>
